import axios from 'axios';

const httpAxios = axios.create({

});

/**
 * 공통 api 통신 모듈
 * @param {String} url : api url
 * @param {String} method: get, post, delete, put
 * @param {String} type: excel 또는 file 일때  responseType 데이터 유형 arraybuffer 지정
 * @param {Object} params: api url요청과 함께 전송 될 URL 매개 변수입니다
 * @param {Object} data: api url요청에 body로 전송할 데이터입니다.
 * @param {Object} header: 사용자 정의 해더
 * @param {boolean} loading: 로딩바 생성 유무
 * @param {boolean} isAuth: 헤더 토큰 인증 여부
 * @param {boolean} file: true일 때 Content-type을 multipart/form-data
 * @param {number} timeout: 요청시간 초과되기까지 시간(밀리초) 지정
 * 
 */

const send = async ({
  url,
  type,
  data,
  params,
  header,
  timeout,
  baseURL,
  isAuth = true,
  loading = true,
  file = false,
  method = 'get',
}) => {
  let headers = header ? header : {};

  if (file) {
    headers["Content-type"] = "multipart/form-data";
  }

  if (isAuth) {
    const token = await localStorage.getItem("access.token");

    if (!token) console.log("##### not token");

    headers = Object.assign({}, header);
    headers["Authorization"] = `Bearer ${token}`;

  }
  
  return httpAxios({
    baseURL,
    url,
    method,
    data,
    params,
    headers,
    timeout: timeout ? timeout : 100000,
    responseType: type === 'excel' || type === 'file' ? 'arraybuffer' : undefined,
  })
    .then((response) => response)
    .catch(error => {
      const { response } = error;

      console.log("####### http axios error: ", error);
      if (response && response.data) {
        console.log("###### http axios error response: ", response);
        return response
      }
    });
}

export default send;
